import { render, staticRenderFns } from "./PromptAdminView.vue?vue&type=template&id=680f2993&scoped=true"
import script from "./PromptAdminView.vue?vue&type=script&lang=js"
export * from "./PromptAdminView.vue?vue&type=script&lang=js"
import style0 from "./PromptAdminView.vue?vue&type=style&index=0&id=680f2993&prod&scoped=true&lang=scss"
import style1 from "./PromptAdminView.vue?vue&type=style&index=1&id=680f2993&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f2993",
  null
  
)

export default component.exports